import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["day", "startDateInput", "endDateInput", "submitButton", "form"]
  static values = { mode: { type: String, default: "owner" } }

  connect() {
    this.selectedStart = null
    this.selectedEnd = null
  }

  selectDay(event) {
    if (this.modeValue !== "owner") return

    const date = event.currentTarget.dataset.date
    if (!date) return

    if (!this.selectedStart || this.selectedEnd) {
      this.clearHighlights()
      this.selectedStart = date
      this.selectedEnd = null
      event.currentTarget.classList.add("selected")
      this.updateInputs()
    } else {
      if (date <= this.selectedStart) {
        this.clearHighlights()
        this.selectedStart = date
        this.selectedEnd = null
        event.currentTarget.classList.add("selected")
        this.updateInputs()
      } else {
        this.selectedEnd = date
        this.highlightRange()
        this.updateInputs()
      }
    }
  }

  clearSelection() {
    this.selectedStart = null
    this.selectedEnd = null
    this.clearHighlights()
    this.updateInputs()
  }

  highlightRange() {
    this.dayTargets.forEach(el => {
      const d = el.dataset.date
      if (d === this.selectedStart || d === this.selectedEnd) {
        el.classList.add("selected")
        el.classList.remove("in-range")
      } else if (d > this.selectedStart && d < this.selectedEnd) {
        el.classList.add("in-range")
        el.classList.remove("selected")
      } else {
        el.classList.remove("selected", "in-range")
      }
    })
  }

  clearHighlights() {
    this.dayTargets.forEach(el => {
      el.classList.remove("selected", "in-range")
    })
  }

  updateInputs() {
    if (this.hasStartDateInputTarget) {
      this.startDateInputTarget.value = this.selectedStart || ""
    }
    if (this.hasEndDateInputTarget) {
      this.endDateInputTarget.value = this.selectedEnd || ""
    }
  }
}
